export default "__VITE_ASSET__8ep5LU1H__"